import React, { useContext, useMemo } from "react";
import { FormField, FormFieldProps, FormContext } from "@natera/form";

//FormField wrapper that disables automatic scroll-to-error behavior.

const NoScrollFormField: React.FC<FormFieldProps> = (props) => {
  const formContext = useContext(FormContext);

  const noScrollFormContext = useMemo(
    () => ({
      ...formContext,
      scrollToError: () => {},
    }),
    [formContext]
  );

  return (
    <FormContext.Provider value={noScrollFormContext}>
      <FormField {...props} />
    </FormContext.Provider>
  );
};

export default NoScrollFormField;
